module.exports = __webpack_public_path__ + "img/product-bg.5bd953fb.jpg";